import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { Modal as OzoneModal } from 'components/atoms/modal';
import { getMembers } from 'data/members/actions';
import { useProjectDetail } from 'data/projects';
import { ChannelMemberList } from './channel-member-list';

const Modal = styled(OzoneModal)`
  .ant-modal-body {
    height: 60vh;
  }
  .ant-modal-footer {
    border-top: solid 1px var(--border-color);
    padding: var(--layout-01);
  }

  .invite-modal--cta {
    display: none;
    pointer-events: none;
  }

  .invite-modal--empty-state {
    height: calc(100% - var(--layout-01));
    margin-bottom: var(--layout-01);
  }
`;

export const InviteMembersModal: FC<{
  projectId: ProjectId;
  visible: boolean;
  handleOnClose(visibility: boolean): void;
}> = ({ projectId, visible, handleOnClose }) => {
  const dispatch = useDispatch();
  const { data: project } = useProjectDetail(projectId);

  useEffect(() => {
    dispatch(getMembers());
  }, [dispatch]);

  return (
    <Modal
      visible={visible}
      title={<FormattedMessage id="projects.conversations.members" />}
      width={440}
      onCancel={() => handleOnClose(false)}
      footer={null}
      bodyStyle={{
        padding: '0 var(--spacing-05) var(--spacing-05)',
        height: '440px',
        overflow: 'hidden',
      }}
    >
      {project ? <ChannelMemberList project={project} /> : null}
    </Modal>
  );
};
